import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  value: {
    controlType: 1,
    fieldId: 0,
    fieldName: "",
    controlsDataSource: 0,
    dbExtenderId: 0,
    sortAlphabetical: 1,
    dataSources: [],
    dependencies: [],
    availableDependencies: []
  }
};
const extenderItemSlice = createSlice({
  name: "extenderItem",
  initialState,
  reducers: {
    lookup: (state, action) => {
      console.log(action);
      state.value = {
        controlType: action.payload.controlType,
        fieldId: action.payload.fieldId,
        fieldName: action.payload.fieldName,
        controlsDataSource: action.payload.controlsDataSource,
        dbExtenderId: action.payload.dbExtenderId,
        sortAlphabetical: action.payload.sortAlphabetical,
        dataSources: action.payload.dataSources,
        availableDependencies: action.payload.availableDependencies,
        dependencies: action.payload.dependencies
      };
    },
    create: (state, action) => {
      console.log(action);
      state.value = {
        controlType: 1,
        fieldId: action.payload.fieldId,
        fieldName: "",
        controlsDataSource: false,
        dbExtenderId: 0,
        sortAlphabetical: true,
        dataSources: [],
        dependencies: [],
        availableDependencies: action.payload.availableDependencies
      };
    }
  }
});
export const { lookup, create } = extenderItemSlice.actions;
export default extenderItemSlice.reducer;
